export default __webpack_public_path__ + "static/media/lightning.8089daed.mp3";